<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <UpperSidebar v-if="pages" :prop_categories="pages" summary-page-name="Consumption" />
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <BubbleChartCard
          :footprintInfo="CO2Footprint"
          :chartHeight="400"
          :loading="loadingCO2Footprint"
          title="Trees required to offset your annual footprint"
          :chartData="bubbleChart.data"
          :options="bubbleChart.options"
          info-text="This card shows how many trees does it take to offset your annual footprint"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <div class="flex">
          <div class="w-full">
            <DoughnutChartCard
              :footprintInfo="CO2Footprint"
              :loading="loadingCO2FootprintByCategory"
              :chartHeight="300"
              title="Carbon footprint for each category"
              :chartData="doughnutChart.data"
              :options="doughnutChart.options"
              info-text="This card shows your carbon footprint by each category. Click each section to see more detail"
            ></DoughnutChartCard>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="row mt-0 mb-0">
          <div class="col-md-12 pl-0 pr-0">
            <stats-card :loading="loadingCO2FootprintStats" chart-height="100%">
              <div class="icon-big text-center" :class="`icon-${CO2FootprintStats.type}`" slot="header">
                <i :class="CO2FootprintStats.icon"></i>
              </div>
              <div class="numbers" slot="content">
                <p>{{ CO2FootprintStats.title }}</p>
                {{ CO2FootprintStats.value }}
              </div>
              <div class="stats" slot="footer">
                <div class="flex justify-content-between">
                  <div><i :class="CO2FootprintStats.footerIcon"></i> {{ CO2FootprintStats.footerText }}</div>
                  <div>
                    <div
                      v-if="loadingCO2FootprintStats"
                      :class="{ bgBlur: true }"
                      style="height: 20%; width: 100%"
                    ></div>
                    <span class="text-primary"> {{ CO2FootprintStats.secondFooterText }}</span>
                  </div>
                </div>
              </div>
            </stats-card>
          </div>
        </div>
        <div class="row mt-0 mb-0">
          <div class="col-md-12 pl-0 pr-0">
            <BarChartCard
              :loading="loadingCO2FootprintComp"
              :chartHeight="140"
              title="CO2 Footprint compared to other clubs"
              :chartData="AvgCarbonFootprintChart.data"
              :options="AvgCarbonFootprintChart.options"
              info-text="This card shows your CO2 emissions compared to the average statistical club in the USA and also shows your target CO2 emission level which would be optimal for your club based on its size, rounds of golf played in month, and sequestration level."
            ></BarChartCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartCard from '@/components/Cards/ChartCard';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import TotalGasAndFuelConsumptionController from '@/controllers/Consumption/TotalGasAndFuelConsumptionController';
import ConsumptionNotificationsController from '@/controllers/Consumption/ConsumptionNotificationsController';
import PaperTable from '@/components/PaperTable';
import ModalTemplate from '@/components/modals/ModalTemplate';
import TotalWaterConsumptionController from '@/controllers/Consumption/TotalWaterConsumptionController';
import BubbleChartCard from '@/components/Cards/BubbleChartCard';
import DoughnutChartCard from '@/components/Cards/DoughnutChartCard';
import StatsCard from '@/components/Cards/StatsCard';
import BarChartCard from '@/components/Cards/BarChartCard';
import UpperSidebar from '@/components/SidebarPlugin/UpperSidebar';
import ConsumptionPagesController from '@/controllers/Consumption/ConsumptionPagesController';
import CO2FootprintByCategoriesController from '@/controllers/Consumption/CO2FootprintByCategoriesController';
import CO2FootprintController from '@/controllers/Consumption/CO2FootprintController';
import CO2FootprintStatsController from '@/controllers/Consumption/CO2FootprintStatsController';
import CO2FootprintСomparisonController from '@/controllers/Consumption/CO2FootprintСomparisonController';
export default {
  name: 'ConsumptionPage',
  components: {
    UpperSidebar,
    BarChartCard,
    StatsCard,
    DoughnutChartCard,
    BubbleChartCard,
    ModalTemplate,
    PaperTable,
    MoonLoader,
    ChartCard,
  },
  data() {
    return {
      bubbleChart: {
        type: 'bubble',
        data: {
          datasets: [
            {
              data: null,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          animation: {
            duration: 2000,
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                },
              },
            ],
          },
          labels: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        },
      },
      seed: null,
      treeWidth: 0,
      treeHeight: 0,
      doughnutChart: {
        data: {
          labels: ['Fuel', 'Gas', 'Diesel', 'Electricity', 'Water'],
          datasets: [
            {
              label: 'Dataset 1',
              data: [42, 54, 32, 63, 32],
              backgroundColor: ['#FFC105', '#73AB6B', '#DC3544', '#A4D1DE', '#8DA1B9'],
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          animation: false,
          showAllTooltips: true,
          onClick: this.handle,
          onHover: (event, chartElement) => {
            event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
          },
          tooltips: {
            callbacks: {
              title: function (tooltipItem, data) {
                return data['labels'][tooltipItem[0]['index']];
              },
              label: function (tooltipItem, data) {
                return data['datasets'][0]['data'][tooltipItem['index']] + '%';
              },
            },
            caretSize: 0,
            backgroundColor: '#F4F3EF',
            titleFontSize: 16,
            titleMarginBottom: 10,
            titleFontColor: '#93918C',
            titleAlign: 'right',
            bodyFontColor: '#000',
            bodyFontSize: 14,
            bodyFontWeight: 'bold',
            bodyAlign: 'center',
            cornerRadius: 8,
            displayColors: false,
            bodyFontFamily: 'Montserrat',
            titleFontFamily: 'Montserrat',
            xAlign: 'center',
            yAlign: 'center',
          },
          legend: {
            display: false,
          },
        },
      },
      AvgCarbonFootprintChart: {
        data: {
          labels: ['Vivid Leaf average', 'US average', 'Your Co2 footprint'],
          datasets: [
            {
              label: 'Dataset 1',
              data: [0.76, 1.243, 3.675],
              backgroundColor: ['#FFC105', '#73AB6B', '#DC3544'],
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          animation: false,
          showAllTooltips: true,
          tooltips: {
            callbacks: {
              title: function () {},
              label: function (tooltipItem, data) {
                let num = data['datasets'][0]['data'][tooltipItem['index']];
                if (num > 999 && num < 1000000) {
                  return (num / 1000).toFixed(2) + 'K'; // convert to K for number from > 1000 < 1 million
                } else if (num > 1000000) {
                  return (num / 1000000).toFixed(2) + 'M'; // convert to M for number from > 1 million
                } else if (num < 900) {
                  return num; // if value < 1000, nothing to do
                }
              },
            },
            caretSize: 0,
            backgroundColor: '#F4F3EF',
            titleFontSize: 16,
            titleMarginBottom: 10,
            titleFontColor: '#93918C',
            titleAlign: 'center',
            bodyFontColor: '#000',
            bodyFontSize: 14,
            bodyFontWeight: 'bold',
            bodyAlign: 'center',
            cornerRadius: 8,
            displayColors: false,
            bodyFontFamily: 'Montserrat',
            titleFontFamily: 'Montserrat',
            xAlign: 'center',
            yAlign: 'center',
          },
          legend: {
            display: false,
          },
          plugins: {
            title: {
              display: true,
              text: 'Chart.js Doughnut Chart',
            },
          },
        },
      },
      pages: ConsumptionPagesController.pages(),
      loadingCO2FootprintByCategory: false,
      CO2FootprintByCategories: null,
      loadingCO2Footprint: false,
      CO2Footprint: {
        total_co2_footprint: 93425,
        co2_sequestration: 1219413.5889601589,
        co2_footprint_minus_co2_sequestration: 1125988.5889601589,
        each_tree_costs: 154.32358353,
        target: 14917164.3984,
      },
      loadingCO2FootprintComp: false,
      CO2FootprintComp: null,
      loadingCO2FootprintStats: false,
      CO2FootprintStats: {
        title: 'CO2 Sequestration',
        value: '367.13k lbs',
        icon: 'fas fa-leaf',
        type: 'success',
        footerIcon: 'ti-calendar',
        footerText: '2021',
        secondFooterText: '2000 is equal to 2000 trees',
        diffPrevMonth: 2000,
      },
    };
  },
  created() {
    this.seed = Date.now();
    this.loadCO2footprintByCategory();
    this.loadCO2footprint();
    this.loadCO2FootprintStats();
    this.loadCO2FootprintComp();
  },
  methods: {
    handle(point, event) {
      const item = event[0];
      let label = item._chart.data.labels[item._index];
      let value = item._chart.data.datasets[0].data[item._index];
      this.moveToPage(label);
    },

    async loadGasAndFuelConsumptionData() {
      this.loadingGasAndFuelConsumptionData = true;
      let totalGasAndFuelConsumptionData = await this.getTotalGasAndFuelConsumptionData();
      await this.setTotalGasAndFuelConsumptionData(totalGasAndFuelConsumptionData);
      this.loadingGasAndFuelConsumptionData = false;
      return totalGasAndFuelConsumptionData;
    },
    async getTotalGasAndFuelConsumptionData() {
      return await TotalGasAndFuelConsumptionController.index();
    },
    async setTotalGasAndFuelConsumptionData(totalGasAndFuelConsumption) {
      this.totalGasAndFuelConsumption = totalGasAndFuelConsumption;
    },

    async loadWaterConsumptionData() {
      this.loadingWaterConsumption = true;
      this.totalWaterConsumption = await TotalWaterConsumptionController.index();
      this.loadingWaterConsumption = false;
    },
    getBubbleChartData(count) {
      return this.bubbles({ count: count, rmin: 10, rmax: 10, min: 0, max: 98.5 });
    },
    getTreeImage(width, height) {
      let treeImage = new Image(width, height);
      treeImage.src = 'https://s3.amazonaws.com/vividleaf.storage/icons/consumption/tree_icon.png';
      return treeImage;
    },
    numbers(config) {
      var cfg = config || {};
      var min = cfg.min;
      var max = cfg.max;
      var from = [];
      var count = cfg.count;
      var decimals = 8;
      var continuity = 1;
      var dfactor = Math.pow(10, decimals) || 0;
      let data = [];
      var i, value;

      for (i = 0; i < count; ++i) {
        value = (from[i] || 0) + this.rand(min, max);
        if (this.rand() <= continuity) {
          data.push(Math.round(dfactor * value) / dfactor);
        } else {
          data.push(null);
        }
      }

      return data;
    },

    points(config) {
      const xs = this.numbers(config);
      const ys = this.numbers(config);
      return xs.map((x, i) => ({ x, y: ys[i] }));
    },

    bubbles(config) {
      return this.points(config).map((pt) => {
        pt.r = this.rand(config.rmin, config.rmax);
        return pt;
      });
    },

    rand(min = 0, max = 0) {
      this.seed = (this.seed * 9301 + 49297) % 233280;
      return min + (this.seed / 233280) * (max - min);
    },

    moveToPage(name) {
      name = name.toLowerCase();
      if (name === 'water') this.$router.push({ name: name + ' consumption' });
      else this.$router.push({ name: name });
    },

    updateTreeChart(CO2Footprint) {
      let coefficient = 10;
      let numberOfTrees = Math.abs(
        Math.round(CO2Footprint.co2_footprint_minus_co2_sequestration / CO2Footprint.each_tree_costs)
      );
      if (numberOfTrees > 100000) {
        coefficient = 100;
      }
      for (let i = 0; i < numberOfTrees / 100; i++) {
        setTimeout(() => {
          this.bubbleChart = Object.assign({}, this.bubbleChart, {
            data: {
              datasets: [
                {
                  data: this.getBubbleChartData((numberOfTrees += 100) / coefficient),
                  pointStyle: this.getTreeImage(20, 20),
                },
              ],
            },
          });
        }, 1);
      }
    },
    async loadCO2footprintByCategory() {
      this.loadingCO2FootprintByCategory = true;
      this.CO2FootprintByCategories = await CO2FootprintByCategoriesController.index();
      this.updateDoughnutChart(this.CO2FootprintByCategories.datasets);
      this.loadingCO2FootprintByCategory = false;
    },
    updateDoughnutChart(datasets) {
      console.log(datasets);
      this.doughnutChart = Object.assign({}, this.doughnutChart, {
        data: {
          labels: this.CO2FootprintByCategories.labels,
          datasets: datasets,
        },
      });
    },

    async loadCO2footprint() {
      this.loadingCO2Footprint = true;
      this.CO2Footprint = await CO2FootprintController.index();
      this.updateTreeChart(this.CO2Footprint);
      this.loadingCO2Footprint = false;
    },

    async loadCO2FootprintStats() {
      this.loadingCO2FootprintStats = true;
      this.CO2FootprintStats = await CO2FootprintStatsController.index();
      this.loadingCO2FootprintStats = false;
    },

    async loadCO2FootprintComp() {
      this.loadingCO2FootprintComp = true;
      this.CO2FootprintComp = await CO2FootprintСomparisonController.index();
      this.updateBarChart(this.CO2FootprintComp.datasets);
      this.loadingCO2FootprintComp = false;
    },
    updateBarChart(datasets) {
      this.AvgCarbonFootprintChart = Object.assign({}, this.AvgCarbonFootprintChart, {
        data: {
          labels: this.CO2FootprintComp.labels,
          datasets: datasets,
        },
      });
    },
    numFormatter(num) {
      if (num > 999 && num < 1000000) {
        return (num / 1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million
      } else if (num > 1000000) {
        return (num / 1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million
      } else if (num < 900) {
        return num; // if value < 1000, nothing to do
      }
    },
  },
};
</script>

<style scoped></style>
